<template>
  <template-cart-button></template-cart-button>
</template>

<script lang="ts">

import templateCartButton from '@/app-template/lib/components/CartButton.vue';

export default {
  components: { templateCartButton },
};
</script>